import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { loadPersons } from '@/api/query/loadPersons';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useLanguage } from '@/common/hooks/useLanguageData';
import { buildPersonListQuery } from '@/common/utils/personListQuery';
import { MY_SOFTIES_PAGE_SIZE } from '../constants/mySofties.constants';

export const useMySofties = () => {
	const { isLoggedIn } = useGuestAuth();
	const { lang } = useLanguage();
	const [persons, setPersons] = useState([]);
	const [selectedProfile, setSelectedProfile] = useState();
	const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);

	const loadPeopleMutation = useMutation({
		mutationFn: (payload) => loadPersons(payload),
		onSuccess: ({ data }) => {
			setPersons(data ?? []);
			setIsInitialFetchDone(true);
		},
		onError: () => {
			setPersons([]);
			setIsInitialFetchDone(true);
		},
	});

	useEffect(() => {
		if (!isLoggedIn) {
			setPersons([]);
			setIsInitialFetchDone(true);
			return;
		}

		setPersons([]);
		setIsInitialFetchDone(false);
		loadPeopleMutation.mutate(
			buildPersonListQuery({
				skip: 0,
				limit: MY_SOFTIES_PAGE_SIZE,
				language: lang,
				owned: true,
			}),
		);
	}, [lang, isLoggedIn]);

	return {
		persons,
		selectedProfile,
		setSelectedProfile,
		isLoading: isLoggedIn && !isInitialFetchDone,
	};
};
